import React from "react";
import CountryGenericSkeleton from "./CountryGenericSkeleton";

function CountryDetailSkeleton() {
  return (
    <>
      <CountryGenericSkeleton />
    </>
  );
}

export default CountryDetailSkeleton;
